import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './material/material.module';
import { LayoutModule } from '@angular/cdk/layout';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MinValueDirective } from '@core/utils/custom-validators/min-value.directive';
import {  DigitOnlyDirective } from '@core/utils/custom-validators/digit-only.directive';
import { TranslateModule } from '@ngx-translate/core';
import { LuxonDurationModule } from 'ng-luxon-duration';
import { NgxMaskModule } from 'ngx-mask';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

import { MccColorPickerModule } from 'material-community-components/color-picker';

FullCalendarModule.registerPlugins([dayGridPlugin, interactionPlugin]);

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    LayoutModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    NgxMaterialTimepickerModule,
    // ChartsModule,
    LuxonDurationModule,
    NgxMaskModule.forRoot(),
    FullCalendarModule,
    MccColorPickerModule.forRoot({}),
  ],
  declarations: [MinValueDirective, DigitOnlyDirective],
  exports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    LayoutModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaterialTimepickerModule,
    TranslateModule,
    MinValueDirective,
    // ChartsModule,
    LuxonDurationModule,
    NgxMaskModule,
    FullCalendarModule,
    MccColorPickerModule,
    DigitOnlyDirective
  ],
})
export class SharedModule {}
